import {useContext, useEffect, useCallback, useState} from 'react';
import {UserContext} from "../common/UserContext";
import {ContentContext} from "../common/ContentContext";
import axios from "../common/axios";
import {TemplateContext} from "../common/TemplateContext";
import {ShortcutContext} from "../common/ShortcutContext";

export default function useCurrentShortcut() {
    const {singlePage, shortcut, setShortcut, setParams} = useContext(TemplateContext);
    const {shortcutMap, shortcutIdMap} = useContext(ShortcutContext);
    const {user, changeCmsMode} = useContext(UserContext);

    const buildQueryString = (params) => {
        if (!params || Object.keys(params).length === 0) {
            return '';
        }

        const queryParams = { ...params };
        delete queryParams._subPath;

        return Object.keys(queryParams).length
            ? '?' + new URLSearchParams(queryParams).toString()
            : '';
    };

    const loadShortcutByUrl = (shortcutUrl, params, hash) => {
        if (shortcutUrl === undefined) {
            return;
        }

        let linkShortcut = shortcutMap.get(shortcutUrl);

        let matchedUrl = shortcutUrl;
        let extraPath = '';

        if (!linkShortcut) {
            const parts = shortcutUrl.split('/').filter(Boolean);

            while (parts.length > 0) {
                const tryUrl = '/' + parts.join('/');
                const candidate = shortcutMap.get(tryUrl);

                if (candidate) {
                    linkShortcut = candidate;
                    matchedUrl = tryUrl;
                    break;
                }

                extraPath = '/' + parts.pop() + extraPath;
            }
        }

        if (linkShortcut) {
            if (extraPath) {
                params = { ...params, _subPath: extraPath };
            }
            loadShortcut(linkShortcut, params, hash);
        } else {
            console.warn(`No shortcut found for URL: ${shortcutUrl}`);
        }
    };

    const loadShortcutById = (shortcutId, params, hash) => {
        if(shortcutId === undefined) {
            return;
        }

        const linkShortcut = shortcutIdMap.get(shortcutId);
        loadShortcut(linkShortcut, params, hash);
    }

    const loadShortcut = async (linkShortcut, params, hash) => {
        if (linkShortcut === undefined) {
            return;
        }

        if (user && user.adminUser && user.cmsMode != linkShortcut.cmsMode) {
            await changeCmsMode(linkShortcut.cmsMode);
        }

        const subPath = params?._subPath || '';

        if (singlePage && linkShortcut.singlePage && shortcut.shortcutId != 126) {
            setParams(params);
            setShortcut(linkShortcut);
            $('.ui-dialog-content').empty().dialog('close');

            if (linkShortcut.url) {
                const fullPath = linkShortcut.url + subPath;
                const triggerHashChange = linkShortcut.url && hash &&
                    (linkShortcut.url === window.location.pathname) &&
                    (hash !== window.location.hash.replace('#'));

                const query = buildQueryString(params);
                const hashFragment = hash ? '#' + hash : '';
                window.history.replaceState({}, '', fullPath + query + hashFragment);

                if (triggerHashChange) {
                    window.dispatchEvent(new HashChangeEvent('hashchange'));
                }
            }
        } else if (linkShortcut.loadFunction !== undefined && typeof linkShortcut.loadFunction === 'string') {
            window[linkShortcut.loadFunction](linkShortcut.name, linkShortcut.url + subPath);
        } else if (linkShortcut.url) {
            // Include params as query string in direct navigation
            const query = buildQueryString(params);
            const hashFragment = hash ? '#' + hash : '';
            window.location.href = linkShortcut.url + subPath + query + hashFragment;
        }
    };

    if(globalReactFunctions !== undefined) {
        globalReactFunctions.loadShortcutByUrl = loadShortcutByUrl;
        globalReactFunctions.loadShortcutById = loadShortcutById;
    }

    return {loadShortcutByUrl,loadShortcutById,loadShortcut};
}